import { gql, useQuery } from "@apollo/client"
import { useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"

const LiabilityClaimRedirectQuery = gql`
    query LiabilityClaimRedirectQuery($id: ID!) {
        liabilityClaim(id: $id) {
            id
            incident {
                id
            }
        }
    }
`

const LiabilityClaimRedirect = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const { data, loading, error } = useQuery(LiabilityClaimRedirectQuery, {
        variables: { id },
        skip: !id,
    })

    useEffect(() => {
        const incidentId = data?.liabilityClaim?.incident?.id
        if (incidentId) {
            navigate(`/incident/${incidentId}#claims`, { replace: true })
        }
    }, [data?.liabilityClaim?.incident?.id, navigate])

    if (loading) {
        return <div className="p-3">Opening liability claim...</div>
    }

    if (error || !data?.liabilityClaim?.incident?.id) {
        return (
            <div className="p-3">
                Unable to find the incident for this liability claim.{" "}
                <Link to="/incidents/claims/#liability">Go to Liability Claims List</Link>
            </div>
        )
    }

    return <div className="p-3">Redirecting...</div>
}

export default LiabilityClaimRedirect
